import { NewItemFab, SearchBar, SelectChip } from "@legacy-megarax/ui-components";
import { FilterList as FilterIcon } from "@mui/icons-material";
import { Box, useMediaQuery } from "@mui/material";
import React from "react";

import { UserProfile } from "@megaron/auth-contracts";

import { getSalespersonDisplayName } from "./TradeRoutesHome";
import { QueryFilters } from "./TradeRoutesHomeContainer";

interface Props {
  qs: QueryFilters;
  setQs: (key: keyof QueryFilters, value: QueryFilters[keyof QueryFilters]) => void;
  salespeople: UserProfile[];
  onClickNew: () => void;
}

export const TopBar: React.FC<Props> = ({ qs, setQs, salespeople, onClickNew }) => {
  const isDesktop = useMediaQuery("(min-width:640px)");

  const Filters = () => (
    <Box px={2} py={1} display="flex" sx={{ gap: 1 }} alignItems="center" justifyContent="flexStart" flexWrap="nowrap">
      <FilterIcon />
      <SelectChip
        label={"Handlowiec"}
        value={qs.userId ?? null}
        options={salespeople.map((salesperson) => ({
          label: getSalespersonDisplayName(salesperson),
          value: salesperson.legacyUserId,
        }))}
        onChange={(value) => setQs("userId", value ? value.toString() : undefined)}
      />
    </Box>
  );

  const NewItemButton = () => <NewItemFab onClick={() => onClickNew()} text="Nowa" />;

  if (!isDesktop)
    return (
      <Box py={2}>
        <Box display="flex" px={2} sx={{ gap: "8px" }} justifyContent="space-between" alignItems="center">
          <SearchBar onSearchChange={(value) => setQs("searchText", value)} initialValue={qs.searchText} />
          <NewItemButton />
        </Box>
        <Filters />
      </Box>
    );
  return (
    <Box p={2} display="flex" sx={{ gap: 1 }} alignItems="center" justifyContent="flexStart">
      <SearchBar onSearchChange={(value) => setQs("searchText", value)} initialValue={qs.searchText} />
      <Filters />
      <Box ml="auto">
        <Box>
          <NewItemButton />
        </Box>
      </Box>
    </Box>
  );
};
